module.exports = __webpack_public_path__ + "media/images/pic/courses/ryotaro-sakamoto2-d9d4a59ebcbb2055d66472ba230469b7.png";